/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import { useDtfStore } from "../store";
import "./LettersFont.scss";
import { renderList } from "common/vue/render-list";

export default function LettersFont({ fonts, ...restProps }: any) {
  const store = useDtfStore();

  function letterNumberArtwork() {
    // @ts-expect-error TS(4111): Property 'letterNumberArtwork' comes from an index... Remove this comment to see the full error message
    return store.letterNumberArtwork;
  }

  function handleSelect(option: any) {
    const font = option.value;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      font
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateAllLetterPreviews();
  }

  return (
    <div {...restProps} className={cn("letters-font", restProps.className)}>
      {renderList(fonts, font => (
        <div
          className={cn(
            "letters-font__item",
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            letterNumberArtwork().font === font.value && "letters-font__item--selected"
          )}
          key={font.value}
          onClick={() => {
            handleSelect(font);
          }}
          data-testid="letters-font-div"
        >
          <div className={cn("letters-font__text", `letters-font__text--${font.value}`)}>
            {" "}
            ABCD{" "}
          </div>
          <span className="letters-font__label">{font.label}</span>
        </div>
      ))}
    </div>
  );
}
